import { useEffect, useState } from 'react';

import useApi from 'utils/hooks/api/useApi';
import { ALERT_VARIANTS } from 'utils/constants';
import { useRoot } from 'context/RootContext';
import { useTranslation } from 'react-i18next';
import { LOCALIZATION_PAGES, API_ENDPOINTS, API_QUERY } from 'utils/constants';

const rolesQuery = { name: '', ...API_QUERY };

const useRoles = (query = rolesQuery) => {
  const queryString = `${API_ENDPOINTS.ROLES}?Name=${query.name}&PageSize=${query.pageSize}&Page=${query.page}&RetrieveAll=${query.retrieveAll}&IncludeCount=${query.includeCount}&SortBy=${query.sortBy}&SortOrder=${query.sortOrder}&Includes=${query.includes}`;
  const { t } = useTranslation(LOCALIZATION_PAGES.ROLES);
  const { showNotification } = useRoot();
  const [path, setPath] = useState(queryString);

  useEffect(() => {
    setPath(queryString);
  }, [queryString]);

  const [{ result, loading: loadingRoles, error: errorRoles }, getRoles] = useApi(path);

  useEffect(() => {
    if (errorRoles) {
      showNotification(
        {
          message: t('alert_fetch_fail'),
        },
        ALERT_VARIANTS.DANGER
      );
    }
  }, [errorRoles, showNotification, t]);

  return [{ result, loadingRoles, errorRoles }, getRoles];
};

export default useRoles;
